import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../../components/DataTable/DataTableLatest";
import DeleteDialog from "../../../components/DialogBoxComponent/DeleteDialog";
import Toast from "../../../components/ToastContainer/CustomToast";
import EditIcon from "../../../Pages/Person/EditIcon";
import { listInvitations } from "../../../slices/Invitations/InvitationsSlice";
import { deleteSite, getAllSites } from "../../../slices/Site/SiteSlice";
import { ThemeContext } from "../../../theme/ThemeContext";
import AddSite from "./AddSite";
import SiteFilter from "./SiteFilter";
import SiteViewDialog from "./SiteViewDialog";

function Site() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [updateObject, setUpdateObject] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [searchedRows, setSerchedRows] = useState([]);
  const [controlRendering, setControlRendering] = useState(false);
  const { t } = useTranslation();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);

  const zlink = localStorage.getItem("redirectFrom");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });
  const [filter, setFilter] = useState({
    name: "",
    parentId: "",
  });

  const [filterr, setFilterr] = React.useState({
    status: ["APPROVED", "CHECKED_IN", "CHECKED_OUT"],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "SELF_REGISTARTION",
    ],
    isPagable: true,
    siteId: "",
  });

  const [pagingg, setPagingg] = useState({
    page: 1,
    rowsPerPage: 1000,
  });

  const defaultFilter = {
    name: "",
    parentId: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpenEditDialog(true);
    setDiaLogBoxBlur(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const deleteIds = (id) => {
    const payload = {
      ...payload,
      siteId: id,
      status: ["APPROVED", "CHECKED_IN", "CHECKED_OUT"],
    };
    dispatch(listInvitations(Object.assign(payload, pagingg)))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data) {
          const visitss = data.data.visits;
          if (visitss === undefined) {
            dispatch(deleteSite(id))
              .unwrap()
              .then((data) => {
                if (data.code === "LMSI6012") {
                  Toast(data.message, "success");
                  setDel(true);
                  loadData(filter, paging);
                } else Toast(data.message, "error");
              })
              .catch((er) => { });
          } else {
            Toast(t("INVITATIONFORM022"), "error");
          }
        }
      })
      .catch((er) => { });
  };

  const loadData = (filter, paging) => {
    dispatch(getAllSites(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setRows(data.data.site);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleEditSite = (rowData) => {
    setUpdateObject(rowData);
    setOpenEditDialog(true);
    setDiaLogBoxBlur(true);
  };

  const handleControlRendering = () => {
    setControlRendering(true);
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
      parentId: data.parentId,
    });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const columns = React.useMemo(
    () => [
      {
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return <div></div>;
        },
      },
      {
        field: "name",
        headerName: t("COMMON044"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.name,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.name}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.name)}</span>
          </Tooltip>
        ),
      },

      !zlink
        ? {
          field: "parentName",
          headerName: t("COMMON050"),
          flex: 1,
          width: 10,
          valueGetter: (params) => params.row.parentName,
        }
        : {},

      {
        field: "description",
        headerName: t("SITE009"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.description,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.description}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row.description)}</span>
          </Tooltip>
        ),
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 205,
        width: 150,
        headerAlign: "center",
        getActions: (params) => [
          <SiteViewDialog key="view" data={params.row} />,
          !zlink && (
            <Box onClick={() => handleEditSite(params.row)}>
              <EditIcon />
            </Box>
          ),
          !zlink && (
            <Box>
              <DeleteDialog
                handleDelete={() => {
                  setFilterr({
                    ...filterr,
                    siteId: params.row.id,
                  });
                  deleteIds(params.row.id);
                }}
                text={"Are you sure you want to delete the "}
                name={"selected record"}
              />
            </Box>
          ),
        ],
      },
    ],
    [handleEditSite, deleteIds]
  );
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Box>
        <Typography variant="h3" style={{ color: darkMode ? "#ffff" : "" }}>
          {t("SITE014")}
        </Typography>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "3px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("SITE013")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <SiteFilter
            onSubmit={(data) => {
              handleFilter(data);
            }}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {openEditDialog && (
        <AddSite
          selectedObject={updateObject}
          open={openEditDialog}
          onClose={() => {
            setOpenEditDialog(false);
            setUpdateObject({});
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
          }}
        />
      )}
    </>
  );
}

export default Site;
